import { render, staticRenderFns } from "./AreaClusters.vue?vue&type=template&id=6678e46e"
import script from "./AreaClusters.vue?vue&type=script&lang=js"
export * from "./AreaClusters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports